import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { routes } from '../../routes/Routes';
import { MenuPage } from '../../layouts';
import { authenticationService } from '../../services';
import { makePost } from '../../api/ajax';
import { selectors as customerSelectors } from '../../redux/customers';

import './sass/representative.scss';

const Representative = () => {
  const [representatives, setRepresentatives] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const history = useHistory();
  const currentCustomer = useSelector(customerSelectors.selectCurrentCustomer);

  useEffect(() => {
    const currentUser = authenticationService.currentUserValue;
    if (currentUser && currentUser.representatives && currentUser.representatives.length > 0) {
      setRepresentatives(currentUser.representatives);
    } else {
      history.push(routes.home);
    }
  }, [history]);

  const filteredRepresentatives = representatives
    .filter((rep) => rep.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      if (a.isHome) return -1;
      if (b.isHome) return 1;
      return a.name.localeCompare(b.name);
    });

  const handleCompanySelect = (representative) => {
    if (currentCustomer.id === representative.id) {
      history.push(routes.home);
    } else {
      makePost('session/representCustomer', { customerId: representative.id })
        .subscribe(
          (data) => {
            authenticationService.storeUserData(data.response);
            window.location.href = routes.home;
          }
        );
    }
  };

  return (
    <MenuPage currentRoute={routes.representative} hideMenu>
      <div className="representative-page">
        <div>
          <div className="representative-container">
            <h2 className="representative-title">Select a Company</h2>
            <p className="representative-subtitle">Choose which company you'd like to represent</p>

            <div className="representative-search">
              <svg className="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d={
                    'M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 '
                    + '10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z'
                  }
                  stroke="#6c757d"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 14L11.1 11.1"
                  stroke="#6c757d"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <input
                type="text"
                placeholder="Search companies..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>

            <div className="representative-list">
              {[...filteredRepresentatives].map((rep) => (
                <button
                  key={rep.id}
                  className="representative-item"
                  onClick={() => handleCompanySelect(rep)}
                  type="button"
                >
                  <div className="representative-icon">
                    {rep.isHome ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                          d={
                            'M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 '
                            + '19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z'
                          }
                          stroke="#495057"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9 22V12H15V22"
                          stroke="#495057"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M3 21H21M5 21V7L13 3V21M19 21V11L13 7M9 9V9.01M9 12V12.01M9 15V15.01M9 18V18.01"
                          stroke="#495057"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                  <div className="representative-info">
                    <div className="representative-name">
                      {rep.name}
                      {rep.registrationNo && <span className="representative-registration"> &middot; {rep.registrationNo}</span>}
                    </div>
                    <div className="representative-role">
                      {rep.role}
                    </div>
                  </div>
                  <div className="representative-arrow">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M6 12L10 8L6 4"
                        stroke="#6c757d"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </button>
              ))}
            </div>

            <div className="representative-footer">
              You represent <strong>{representatives.length}</strong> companies
            </div>
          </div>

          <div className="representative-copyright">
            DriveX Technologies OÜ copyright
          </div>
        </div>
      </div>
    </MenuPage>
  );
};

export default Representative;
